var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigDelivery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 60,
    viewBox: "0 0 85 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 30.5,
    r: 29.5,
    fill: "#78E08F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3362,
    cy: 42.022,
    r: 8.94526,
    stroke: "black",
    strokeWidth: 1.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.1011,
    cy: 42.022,
    r: 8.94526,
    stroke: "black",
    strokeWidth: 1.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3366,
    cy: 42.0219,
    r: 1.56132,
    stroke: "black",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1541 44.073L34.592 44.4832L21.8752 28.8949C27.4542 17.7369 37.4636 16.9985 41.976 16.9985C35.4125 25.2029 36.6431 35.3217 38.284 39.1504H45.668L49.7701 33.4073L47.4805 30.736C46.4458 29.529 47.3035 27.6642 48.8933 27.6642H55.9234L73.1526 20.2803C73.4808 24.5466 75.7507 25.8866 76.8446 26.0234L76.0242 28.8949L57.1541 44.073Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0286 22.7417H51.4553C49.4166 22.7417 47.5529 23.8935 46.6412 25.7169C46.1938 26.6116 46.8444 27.6643 47.8447 27.6643H55.923L73.5624 19.8701H62.4865L55.3151 22.5122C54.9032 22.664 54.4676 22.7417 54.0286 22.7417Z",
    stroke: "black",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8254 19.8701H66.8382C63.7552 19.8701 61.2559 17.3708 61.2559 14.2877V6.58234C61.2559 3.4993 63.7552 1 66.8382 1H77.8254C80.9084 1 83.4077 3.4993 83.4077 6.58234V14.2877C83.4077 17.3708 80.9084 19.8701 77.8254 19.8701Z",
    fill: "#FFE493",
    stroke: "black",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2559 6.74316H83.4077",
    stroke: "black",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3854 16.5883H31.7197C31.7197 12.322 34.728 10.982 36.2321 10.8452H38.6639C40.7192 10.8452 42.3854 12.5114 42.3854 14.5668V16.5883Z",
    stroke: "black",
    strokeWidth: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0535 16.5883V6.33279M37.0535 6.33279V5.71746C37.0535 3.3386 38.9819 1.41016 41.3608 1.41016V1.41016C42.1537 1.41016 42.7965 2.05297 42.7965 2.84592V4.47201C42.7965 5.49969 41.9634 6.33279 40.9358 6.33279H37.0535Z",
    stroke: "black",
    strokeWidth: 1.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8088 30.1118C19.1289 29.4822 20.6519 29.1244 21.8755 28.895L24.3368 32.1768H18.5985C17.1521 32.1768 16.5033 30.7344 17.8088 30.1118Z",
    stroke: "black",
    strokeWidth: 1.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5464 43.5833L63.6161 39.6402H71.5117C72.6005 39.6402 73.4832 40.5229 73.4832 41.6118C73.4832 42.7006 72.6005 43.5833 71.5117 43.5833H58.5464Z",
    stroke: "black",
    strokeWidth: 1.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70.3298,
    y1: 39.2033,
    x2: 67.8685,
    y2: 35.1011,
    stroke: "black",
    strokeWidth: 1.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.3411,
    y1: 40.5653,
    x2: 28.6229,
    y2: 37.2835,
    stroke: "black",
    strokeWidth: 1.8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.9,
    y1: -0.9,
    x2: 4.60367,
    y2: -0.9,
    transform: "matrix(0.89444 0.447187 -0.44724 0.894414 76.0234 28.895)",
    stroke: "black",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 61.2559,
    y1: 9.94521,
    x2: 83.4077,
    y2: 9.94522,
    stroke: "black",
    strokeWidth: 1.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 67.0792,
    y1: 10.0249,
    x2: 67.0792,
    y2: 19.8702,
    stroke: "black",
    strokeWidth: 1.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 78.5646,
    y1: 10.0249,
    x2: 78.5646,
    y2: 19.8702,
    stroke: "black",
    strokeWidth: 1.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigDelivery);
export default __webpack_public_path__ + "static/media/big-delivery.2a1596b3fdb06ad307e9bb8eb4014e4f.svg";
export { ForwardRef as ReactComponent };